// 基础
import './ui'
import './permission'

// 全家桶
import Vue from 'vue'
import App from './App'
import store from './store';
import router from './route'
import i18n from './lang';

// 初始化Vue
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')